import { type ModalProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { Modal } from 'components/ui';

interface ConfirmationModalProps extends ModalProps {
  message: string | JSX.Element;
  loading?: boolean;
}

export const ConfirmationModal: React.FunctionComponent<ConfirmationModalProps> = ({
  message,
  title,
  okText,
  cancelText,
  loading = false,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={title || t('common.confirmTitle', 'Are you sure?')}
      okText={okText || t('common.yes', 'Yes')}
      okButtonProps={{ loading, 'data-testid': 'confirmation-modal-ok-button' }}
      cancelText={cancelText || t('common.no', 'No')}
      {...props}
    >
      {message}
    </Modal>
  );
};
